import { useMutation } from "@apollo/client/react";
import { UPDATE_INVOICE_RECIPIENT } from "../../mutations/invoices/updateInvoiceRecipient";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export const useUpdateInvoiceRecipient = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [updateInvoiceRecipient, { data, loading, error }] = useMutation(
    UPDATE_INVOICE_RECIPIENT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: noRefetch
        ? []
        : [
            GET_INVOICE_LATEST_VALIDATION_RESULT,
            GET_INVOICE_ASSESSMENT_DETAILS,
          ],
      awaitRefetchQueries: true,
    },
  );

  return { updateInvoiceRecipient, data, loading, error };
};
